import * as React from 'react';
import ReviewForm from '../../components/forms/ReviewForm';
import {useParams } from 'react-router-dom';
import { FormDataBuilder, makeFormControls, validateForm } from '../../components/formElements/util';
import { isEmail, isEmpty, isTable } from '../../components/formElements/validators';
import { api } from '../../environment';
import { Link } from 'react-router-dom';

export default function Review(){

    const {hash} = useParams();

      let formDataBuilder = new FormDataBuilder();
    let activity_id = 0;
       const thematicFields = [
  {value:"1", text:"Mentalno zdravlje u različitim životnim razdobljima i kontekstima"},
  {value:"2", text:"Klinička i zdravstvena psihologija: procjena, dijagnostika i tretman"},
  {value:"3", text:"Psihologija u obrazovanju i razvoju karijere"},
  {value:"4", text:"Rad, organizacije i specifični profesionalni sustavi"},
  {value:"5", text:"Zajednica, društveni kontekst i sustavi skrbi"},
  {value:"6", text:"Digitalno okruženje, mediji i suvremene tehnologije"},
  {value:"7", text:"Raznolikost, identitet i ljudska prava"},
  {value:"8", text:"Profesionalni identitet, etika i razvoj struke"}
]

    formDataBuilder= formDataBuilder
	.addSubtitle("Prijavljeni sažetak")
	.addTextField("activity_title", "Naslov", true, true, [isEmpty], {flex:"1 1 45%"})
        .addSelectField("type", "Oblik izlaganja", true, [
	    {value:"1", text:"Usmeno izlaganje - Psihologija u fokusu"},
	    {value:"2", text:"Usmeno izlaganje - Psihologija u akciji"},
	    {value:"3", text:"Simpozij"},
	    {value:"4", text:"Okrugli stol"},
	    {value:"5", text:"Panel rasprava"},
	    {value:"6", text:"Radionica"},
	    {value:"7", text:"Poster izlaganje"},
	    {value:"8", text:"Stručni domjenak"},
	    {value:"9", text:"Sastanak stručne sekcije/radne skupine"},
	    {value:"10", text:"Predstavljanje knjiga, psihologijskih mjernih instrumenata te drugih publikacija i uradaka"},
	    {value:"11", text:"Ostale aktivnosti"}], true, [isEmpty], {flex:'1 1 100%'})
        .addSelectField("theme", "Tematsko područje", true, thematicFields, true, [isEmpty], {flex:'1 1 100%'})
	.addTextArea("abstract", "Tekst sažetka", true, [isEmpty], {flex:"1 1 100%"}, {}, 20)
	.addTextField("keywords", "Ključne riječi", true, true, [isEmpty], {flex:"1 1 45%"})
	.addSubtitle("A. RECENZIJSKA PITANJA - označiti svaku istinitu tvrdnju, a one koje nisu zadovoljene iskomentirati u dijelu B.")
	.addCheckboxAdvanced("formalRequest", "1. Sažetak zadovoljava formalne zahtjeve.", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("necessaryElements","2. Sažetak sadrži sve obvezne elemente propisane za prijavljeni oblik sudjelovanja.", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("structure","3. Sažetak slijedi propisanu strukturu i upute za autore za prijavljeni oblik sudjelovanja.", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("goal","4. Cilj rada, projekta, aktivnosti ili istraživački problem su jasno formulirani.", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("method","5. Sadržaj i način provedbe (npr. metodologija, aktivnosti, plan rada ili organizacija, ovisno o obliku sudjelovanja) su jasno i primjereno opisani.", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("results","6. Rezultati, ishodi ili očekivani doprinos rada/aktivnosti su jasno prikazani", false, [], {flex:"1 1 100%"})
	.addCheckboxAdvanced("clean","7. Tekst je organiziran, razumljiv i jezično uredan.", false, [], {flex:"1 1 100%"})
	.addSubtitle("B. Komentari recenzenta")
	.addTextArea("comment", "Upišite komentare ovdje. Komentirajte samo djelove koje je potrebno doraditi - ako je dio kvalitetno napisan, nije ga potrebno posebno komentirati.", false, [], {flex:"1 1 100%"}, {}, 15)
	.addSubtitle("Opća preporuka")
	.addSelectField("recommend", "Odaberite opciju", true, [
	    {value:"-1", text: ""},
	    {value:"1", text:"Prihvatiti u postojećem obliku"},
	    {value:"2", text:"Prihvatiti uz manje dorade"},
	    {value:"3", text:"Prihvatiti nakon značajnih izmjena (potrebna ponovna provjera)"},
	    {value:"4", text:"Ne prihvatiti"}
	], true, [isEmpty],{flex:'1 1 100%'})
	.addTextField("changeType", "Preporuka izmjene oblika sudjelovanja", false, false, [], {flex:"1 1 45%"})

    const makeFormData = ()=>{
	return formDataBuilder.get()
    }
    
    const [formData, setFormData] = React.useState(makeFormData());
    const [formControls, setFormControls] = React.useState(null);
    const [activityId, setActivityId] = React.useState(0);
    const [links, setLinks] = React.useState([]);
    const getData = () => {
        let call = fetch(api+"/get_review_data",{
            method: "POST",
            body:JSON.stringify({
                hash:hash
            })
            })
            try{
		return call.then(response=>{
		    return response.json()
		})
            } catch(err){
                console.log(err);
                return {}
            }
    }

    React.useEffect(()=>{

	getData().then(
	    	(data)=>{
		    console.log('DATA', data);
		    setFormData(()=>{
			return formDataBuilder.get()
		    })
		    console.log("formdata", formData)
		    setFormControls(()=>{
			let prevState = makeFormControls(formData);
			for(let key in data['review']){
			    
			    if(prevState[key]!=undefined && prevState[key]!='test'){
				prevState[key].value=data['review'][key]
			    }
			}

			if(data['review']['test']!=undefined){
			    for(let key in data['review']['test']){
				prevState[key].value = data['review']['test'][key]
			    }
			}


			if(data['review']['type'] == 3){
			    let ls = [];

			    for(let child_activity of data['review']['child_activities']){
				ls.push({link:"/recenzija/"+child_activity.hash, text:child_activity.activity_title})
			    }
			    console.log("LINKS", ls)
			    setLinks(ls)
			}
			
			prevState['type'].value = prevState['type'].value.toString()
			prevState['recommend'].value = prevState['recommend'].value.toString()
			return prevState
		    })

		    setActivityId(()=>{
			return data['review']['activity_id']
		    })
		}
	    )
    }, [hash])

    if(formControls==null && activityId == 0){
	return (<></>)
    } else {
    return(
        <div className="flex-column" style={{width:"60vw", margin:"auto",  gap:"1rem", paddingTop:"10vh"}}>
	    <div>
		
		<h2>Kako ispuniti obrazac (upute za recenzente):</h2>
		<p style={{fontSize:"1.2rem"}}>1. Označite svaku istinitu tvrdnju o pregledanom sažetku.</p><br/>
		
		<p style={{fontSize:"1.2rem"}}>2. Ako sažetak ne zadovoljava neki od uvjeta u dijelu A, napišite obrazloženje u dijelu B.</p><br/>

		<p style={{fontSize:"1.2rem"}}>3. Ne zaboravite označiti i "Opću preporuku", pri dnu formulara.</p><br/>

		<p style={{fontSize:"1.2rem"}}><strong>4. Nakon željenih izmjena, kliknite na "Ažurirati", na samom dnu ponuđenog formulara.</strong></p><br/>
	     </div>

	    <div>
		<h2>Kako prepraviti sažetak? (upute za prijavitelje sažetka)</h2>

		<p style={{fontSize:"1.2rem"}}>1. Unesite promjene u odgovarajuća polja u dijelu "Prijavljeni sažetak"</p><br/>
		
		<p style={{fontSize:"1.2rem"}}><strong>2. Nakon željenih izmjena, kliknite na "Ažurirati", na samom dnu ponuđenog formulara.</strong></p><br/>
	
	    </div>
            <ReviewForm hash={hash} formData={formDataBuilder.get()} setFormControls={setFormControls} formControls={formControls} activity_id={activityId} hash={hash} links={links}/>
        </div>
        
    )
    }
}
